import { ComboBox } from "@xola/ui-kit";
import axios from "axios";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { Geo } from "types";
import { useDebounce } from "use-debounce";
import { config } from "../../config";

export const fetchCityOptions = async (search: string) => {
    const response = await axios.get<{ geonames: Geo[] }>(`${config.geonames.url}/searchJSON`, {
        params: {
            username: config.geonames.username,
            featureClass: "P",
            style: "full",
            maxRows: "12",
            name_startsWith: search,
        },
    });
    return response.data.geonames.map((geoname: Geo) => {
        return {
            value: geoname.geonameId,
            label: `${geoname.name}, ${geoname.adminName1}, ${geoname.countryName}`,
            geo: geoname,
        };
    });
};

interface CitySelectProps {
    value: string | null;
    onChange: (value: string | null, geo: Geo | null) => void;
    error?: boolean;
}

export const CitySelect = ({ value, onChange, error }: CitySelectProps) => {
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebounce(search, 500);

    const { data: options, isLoading } = useQuery(["cities", debouncedSearch], async () => {
        return fetchCityOptions(debouncedSearch);
    });

    const handleInputChange = (search: string) => {
        setSearch(search);
    };

    const handleChange = (option: { value: string; label: string; geo: Geo } | null) => {
        if (option) {
            onChange(option.value, option.geo);
        } else {
            onChange(null, null);
        }
    };

    return (
        <ComboBox
            isClearable
            isLoading={isLoading}
            options={options}
            value={value ? { value, label: value } : null}
            isError={error}
            classNames={{ option: () => "no-translate", singleValue: () => "no-translate leading-5" }}
            onInputChange={handleInputChange}
            onChange={handleChange}
        />
    );
};

export const getCityString = (geo?: Geo) => {
    return geo ? `${geo.name}, ${geo.adminName1}, ${geo.countryName}` : "";
};

export const getStateString = (geo?: Geo) => {
    return geo ? `${geo.adminName1}` : "";
};

export const getCountryString = (geo?: Geo) => {
    return geo ? `${geo.countryName}` : "";
};
